export default "__VITE_ASSET__BCUXLAre__"